export default {"src":"/_next/static/media/terraced-icon.1580cf3f.svg","height":87,"width":118,"blurWidth":0,"blurHeight":0};